import React from "react";
import {FC} from "react";
import DtoTable from "../../components/dto-table/dto-table";

import {Breadcrumb} from "antd";
import {Trans} from "@lingui/macro";
import MovementHistoryModel from "../../models/dto/movement-history-model";


const LocationListScreen : FC = () => {

    return (<>
            <Breadcrumb style={{ marginBottom: 10 }}>
                <Breadcrumb.Item><Trans id={'Homepage'}/></Breadcrumb.Item>
                <Breadcrumb.Item><Trans id={'Movement History'}></Trans></Breadcrumb.Item>
            </Breadcrumb>
            <DtoTable
                model={MovementHistoryModel}
                allowRefreshButton={true}
                pageSize={100}
                scroll={{ x: 1300, y: "65vh" }}
            />
        </>
    );
}
export default LocationListScreen;
